import React, {useEffect, useState} from 'react';
import {I18n} from 'react-redux-i18n';

import {useSelector} from 'react-redux';
import {EntityCreatingCard} from '../index';
import {DataExportEditForm} from '../../containers/index';
import {DataExportModel} from '../../types/DataExport';
import {isURLWithProtocol} from '../../utils/validators';

type DataExportCreatingProps = {
  handleClickButtonCancel: () => void,
  // eslint-disable-next-line no-unused-vars
  handleClickButtonSave: (formData: DataExportModel) => void,
}

function DataExportCreating({
  handleClickButtonCancel,
  handleClickButtonSave,
}: DataExportCreatingProps) {
  const accountInfo = useSelector((store: any) => store.operatorLayoutReducer.accountInfo);
  const [formData, setFormData] = useState<DataExportModel>({
    name: '',
    description: '',
    streamTypeId: '',
    frequency: 10,
    collectorUrl: '',
    collectorToken: '',
    filters: {
      allQueries: true,
      threatsDetected: true,
      restrictedContent: true,
    },
    builtinFieldMappingId: '63cd3f2f-a1a5-44bc-9463-23953070c242',
    customFieldMapping: {},
    organizationIds: [],
    enabled: true,
    allOrgs: false,
    siemSpecificData: {},
    status: '',
    lastOperation: '',
  });
  const [isValid, setIsValid] = useState(false);
  const [areSpecificFieldsValid, setAreSpecificFieldsValid] = useState(false);

  useEffect(() => {
    setIsValid(
      !!formData.name &&
      isURLWithProtocol(formData.collectorUrl) &&
      areSpecificFieldsValid &&
      (!accountInfo.organizationsAllowed ||
        formData.allOrgs ||
        formData.organizationIds.length > 0),
    );
  }, [formData]);

  return (
    <EntityCreatingCard
      title={I18n.t('dataExportPage.editForm.title.create')}
      handleClickButtonCancel={handleClickButtonCancel}
      handleClickButtonSave={() => handleClickButtonSave(formData)}
      customCardContentClass="card__content_policy"
      isValidEntity={isValid}
      content={(
        <DataExportEditForm
          dataExport={formData}
          onFormChange={setFormData}
          setAreSpecificFieldsValid={setAreSpecificFieldsValid}
          isEditMode={true}
        />
      )}
    />
  );
}

export default DataExportCreating;
